const topics = [
  { id: 1, name: '明星恋情', count: '128万讨论', hot: true },
  { id: 2, name: '综艺黑幕', count: '96万讨论', hot: true },
  { id: 3, name: '直播塌房', count: '203万讨论', hot: true },
  { id: 4, name: '饭圈互撕', count: '87万讨论', hot: false },
  { id: 5, name: '离婚八卦', count: '156万讨论', hot: true },
  { id: 6, name: '人设崩塌', count: '112万讨论', hot: false },
  { id: 7, name: '代孕风波', count: '73万讨论', hot: false },
  { id: 8, name: '偷税漏税', count: '189万讨论', hot: true },
  { id: 9, name: '整容争议', count: '64万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="section-anchor py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">热议话题</h2>
          <p className="text-sm text-foreground-500 max-w-[600px] mx-auto">当下最火的911吃瓜热点话题标签，点击探索你感兴趣的爆料内容</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer border transition-all duration-300 ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100 hover:border-primary-300'
                  : 'bg-background-50 border-background-200/70 hover:bg-secondary-50 hover:border-secondary-200'
              }`}
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-fill text-accent-500 text-xs"></i>
                </span>
              )}
              <span className={`text-sm font-medium ${topic.hot ? 'text-primary-700' : 'text-foreground-700'} whitespace-nowrap`}>
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}